import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export async function fetchNewStationeryToggle(wedId) {
  if (!wedId) return false

  try {
    const response = await axios.get(
      `${API_URL}/v1/feature-toggle/digital-stationery/${wedId}`
    )

    return response?.data?.data?.enabled || false
  } catch {
    return false
  }
}
